import { useEffect, useRef } from "react";

// Mappa Leaflet (CDN) con marker e percorso a linea.
export default function MapView({ markers = [], route = [], height = 360, testid = "map-view" }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !ref.current) return;
    if (!mapRef.current) {
      mapRef.current = L.map(ref.current, { scrollWheelZoom: false }).setView([45.68, 9.15], 10);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap", maxZoom: 18,
      }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    if (layerRef.current) { map.removeLayer(layerRef.current); }
    const group = L.layerGroup().addTo(map);
    layerRef.current = group;

    const pts = [];
    markers.forEach((m, i) => {
      if (m.lat == null || m.lng == null) return;
      const icon = L.divIcon({
        className: "",
        html: `<div style="background:${m.color || "#3D271D"};color:#fff;width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;font-weight:700;font-size:12px;box-shadow:0 2px 6px rgba(0,0,0,.3)"><span style="transform:rotate(45deg)">${m.label ?? i + 1}</span></div>`,
        iconSize: [28, 28], iconAnchor: [14, 28],
      });
      const mk = L.marker([m.lat, m.lng], { icon }).addTo(group);
      if (m.title) mk.bindPopup(`<b>${m.title}</b>${m.subtitle ? "<br/>" + m.subtitle : ""}`);
      pts.push([m.lat, m.lng]);
    });

    if (route.length > 1) {
      const line = route.filter((p) => p.lat != null && p.lng != null).map((p) => [p.lat, p.lng]);
      if (line.length > 1) L.polyline(line, { color: "#8C4A32", weight: 3, dashArray: "6 8", opacity: 0.8 }).addTo(group);
    }

    if (pts.length > 0) {
      try { map.fitBounds(pts, { padding: [40, 40], maxZoom: 13 }); } catch {}
    }
    setTimeout(() => map.invalidateSize(), 150);
  }, [markers, route]);

  return <div data-testid={testid} ref={ref} style={{ height, width: "100%", borderRadius: "0.9rem" }} className="border border-lm-sandsoft overflow-hidden" />;
}
